module.exports = __webpack_public_path__ + "static/media/bet-games.85448ea2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/bet-games.svg
// module id = 364
// module chunks = 7